var __TEMP__ = require('./_Symbol.js');var Symbol = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = cloneSymbol;
